<template>
  <App>
    <component :is="layout" />
    <Main :appVersion="version" v-if="!loading" />
    <LoadingArea :displayContent="!loading"></LoadingArea>
  </App>
</template>
<script>
import { App, Main, LoadingArea } from '@locaweb/design-system-vue'
import useLayoutStore from '@/store/layout'
import { authStore } from '@/store/auth'
import { computed } from 'vue'
import { addToDataLayer } from '@/config/dataLayerService'
import './layouts'

const version = require('../../package.json').version

export default {
  name: 'TheLayout',
  components: {
    App,
    Main,
    LoadingArea
  },
  setup () {
    const layoutStore = useLayoutStore()
    const userId = computed(() => authStore().userName)

    return { version, layoutStore, userId }
  },
  computed: {
    layout () {
      return `layout-${this.$route.meta.layout || 'default'}`
    },
    loading () {
      return this.layoutStore.isLoading
    }
  },
  mounted () {
    addToDataLayer({
      event: 'userId',
      userId: this.userId
    })
  }
}
</script>

<style lang="scss">
.v-application--without-scroll {
  height: 300px;
  @media only screen and (max-width: 780px) {
    overflow: hidden;
  }
}
</style>
